import { loadStripe } from '@stripe/stripe-js';

// Get Stripe key from environment variable or use bypass mode for development
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_bypass_development_mode';

console.log('🔧 Loading Stripe 3D Secure input fix...');
console.log('🔑 Stripe Key:', STRIPE_PUBLISHABLE_KEY.substring(0, 20) + '...');

// Check if we're in bypass mode (development without real Stripe)
const isBypassMode = STRIPE_PUBLISHABLE_KEY === 'pk_test_bypass_development_mode';

// Initialize Stripe - if bypass mode, use null to prevent loading errors
export const stripePromise = isBypassMode ? Promise.resolve(null) : loadStripe(STRIPE_PUBLISHABLE_KEY);

export const isStripeEnabled = !isBypassMode;

if (isBypassMode) {
  console.log('⚠️ Stripe bypass mode enabled - payments will be simulated');
} else {
  console.log('✅ Stripe 3D Secure input fix loaded');
}

export default stripePromise;
